module.exports = __webpack_public_path__ + "static/media/BrandAccount.dbabcc32.svg";